// Tiny class-name combiner. Wraps clsx so every primitive merges its base
// classes with a caller-supplied `className` the same way. Kept as its own
// module so the import path (`./cn`) is short and stable across the ui layer.
import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
